import Layout from '@/layout';
var orderRouter = {
  path: '/order',
  component: Layout,
  redirect: '/order/list',
  name: 'Order',
  alwaysShow: true,
  meta: {
    title: '订单',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/distribution/storeOrder/index');
    },
    name: 'OrderIndex',
    meta: {
      title: '订单'
    }
  }, {
    path: 'refund',
    component: function component() {
      return import('@/views/distribution/storeRefund/index');
    },
    name: 'refund',
    meta: {
      title: '退款订单'
    }
  }, {
    path: 'reservation',
    component: function component() {
      return import('@/views/order/reservation/index');
    },
    name: 'OrderReservation',
    meta: {
      title: '预约',
      icon: ''
    },
    children: [{
      path: 'service',
      component: function component() {
        return import('@/views/order/reservation/service');
      },
      name: 'Service',
      meta: {
        title: '预约看板',
        icon: ''
      }
    }, {
      path: 'workOrder',
      component: function component() {
        return import('@/views/order/reservation/workOrder');
      },
      name: 'WorkOrder',
      meta: {
        title: '工单管理',
        icon: ''
      }
    }]
  }]
};
export default orderRouter;